import { createAction } from 'redux-actions';
export let treeNodeCreated = createAction('TREE_NODE_CREATED', ({ otid, parent_otid })=>({
        otid,
        parent_otid
    }));
